import { render, staticRenderFns } from "./Versandaufteilung.vue?vue&type=template&id=5806ba50&lang=html&"
import script from "./Versandaufteilung.vue?vue&type=script&lang=js&"
export * from "./Versandaufteilung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports